import React from 'react';
export function ProblemSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-240">
      <div className="max-w-3xl mx-auto" data-id="element-241">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#5B3FA0]" data-id="element-242">
          EL PROBLEMA QUE MUCHOS DOCENTES DE SECUNDARIA VIVEN CADA AÑO
        </h2>

        <p className="text-xl mb-3 font-medium text-center md:text-left" data-id="element-243"></p>

        <ul className="space-y-2 text-lg text-gray-700 mb-5 max-w-2xl mx-auto" data-id="element-244">
          <li className="flex items-start" data-id="element-245">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-246">•</span>
            <span data-id="element-247">Pasás horas buscando material para cada fecha.</span>
          </li>
          <li className="flex items-start" data-id="element-248">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-249">•</span>
            <span data-id="element-250">Encontrás recursos pensados para primaria.</span>
          </li>
          <li className="flex items-start" data-id="element-251">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-252">•</span>
            <span data-id="element-253">Terminás improvisando actividades.</span>
          </li>
          <li className="flex items-start" data-id="element-254">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-255">•</span>
            <span data-id="element-256">
              Repetís propuestas porque no tenés tiempo para buscar otras.
            </span>
          </li>
          <li className="flex items-start" data-id="element-257">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-258">•</span>
            <span data-id="element-259">
              Te cuesta encontrar actividades que realmente hagan pensar a los
              estudiantes.
            </span>
          </li>
        </ul>

        <p className="text-xl text-center mb-3 font-[800] text-[#2E9E8F]" data-id="element-260">
          Lo peor es esa sensación de pensar: "Podría trabajar mejor las
          efemérides si tuviera todo listo."
        </p>
      </div>
    </section>;
}